<template>
  <div class="cashflow-type-recurring card-box">
    <div class="card-wrapper" :class="{ 'showing-edit-menu': showSectionMenu }">
      <div class="header">
        <span class="title">{{ titles.cardTitle }}</span>
        <img class="edit" v-on:click.stop="openSectionMenu"
             :src="require('@/assets/icons/menu.svg')">
      </div>

      <expense-progress :recommended-or-expected-amount="expenses.recommendedOrExpectedAmount"
                        :recommended-or-expected-label="titles.expenseProgress.recommendedLabel"
                        :up-to-now-label="titles.expenseProgress.actualsLabel"
                        :up-to-now-amount="expenses.upToNowAmount"
                        :show-warning-if-exceeding-budget="false"/>

      <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                   :recommended-title="titles.categorySections.recommendedTitle"
                                   :categories="expenses.categories"
                                   :initially-expanded="false"
                                   :show-recommended-title="true"
                                   :is-section-editable="true"
                                   :title="titles.categorySections.mainTitle"
                                   :expense-category="expenseCategory"
                                   v-on:edit-amount-clicked="emitOpenEditAmountPopup"
                                   v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                   v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
        <template v-slot:transactions="slotProps">
          <div class="transaction-list">
            <transaction class="transaction-details"
                             v-for="transaction in slotProps.transactions"
                             :transaction="transaction"
                             :can-edit-category="true"
                             :category-name="getCategoryName(expenseCategory)"
                             v-bind:key="transaction.transactionId">
            </transaction>
          </div>
        </template>
      </predicted-category-sections>
    </div>
    <reccuring-section-menu v-if="showSectionMenu" :expenseCategory="this.expenseCategory"
                                             :expenses="this.expenses"
                                             :closeMenu="() => this.showSectionMenu = false"/>
  </div>
</template>

<script>
import Segment from '../../../../../../../../../Segment';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import Transaction from '../../../generic-components/cashflow-types/cashflow-types-base/Transaction.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import ReccuringSectionMenu from '../cashflow-edit/edit-reccuring/ReccuringSectionMenu.vue';
import EditAmountPopup from '../cashflow-edit/EditAmountPopup.vue';
import ModalBus from '../../../../../../../../../event-bus/modal-bus';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';

export default {
  name: 'CashflowTypeRecurring',
  mixins: [CashflowAnalytics],
  components: {
    Transaction,
    ExpenseProgress,
    PredictedCategorySections,
    ReccuringSectionMenu,
  },
  data() {
    return {
      showSectionMenu: false,
    };
  },
  props: [
    'expenses',
    'expenseCategory',
  ],
  computed: {
    CASHFLOW_TYPE() {
      return this.expenseCategory;
    },
    category() {
      return this.expenses.categories[0];
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'יצא עד עכשיו',
          recommendedLabel: 'סה"כ צפוי לצאת',
        },
        categorySections: {
          actualsTitle: 'יצא',
          recommendedTitle: 'צפוי לצאת',
          mainTitle: `פירוט הוצאות ${this.expenseCategory}`,
        },
        cardTitle: `הוצאות ${this.expenseCategory}`,
      };
    },
  },
  methods: {
    emitOpenEditAmountPopup() {
      ModalBus.$emit('open', {
        component: EditAmountPopup,
        props: {
          expenseCategory: this.expenseCategory,
          category: this.category,
        },
      });
    },
    getCategoryName(expense) {
      const category = _.find(cashflowViewConsts.CATEGORIES, { expense });
      return category.categoryName;
    },
    openSectionMenu() {
      Segment.trackUserInteraction('OpenSectionMenuClicked', {
        expenseCategory: this.expenseCategory,
      });
      this.showSectionMenu = true;
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-recurring {
    @include cashflow-card;
    position: relative;

    .card-wrapper {
      &.showing-edit-menu {
        opacity: 0.5;
      }

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          @include cashflow-card-title;
          white-space: nowrap;
        }

        .edit {
          height: 16px;
          cursor: pointer;
          margin-bottom: 10px;
        }
      }

      .cashflow-type-color {
        color: $riseup_light_blue;
      }

      .cashflow-type-background-color {
        background-color: $riseup_light_blue;
      }
    }
  }

</style>
